export default "__VITE_ASSET__BOHIH9B___"